import { axiosMockAdapterInstance } from "apis/index";
import { getResponseData } from "./index";

export const data = [
  {
    amount: "5",
    blockHash: "0xd5a0ef6b90803adbcc09de5b71262d5bb67256572ab38d246ad5c08116c0e43f",
    blockNumber: 18858906,
    chargeCode: "UNLINKED_5",
    contracAddr: "0xE8BcC65c7a7931b61c8eE45af27b9C85083F35b9",
    createdAt: "2022-04-29T03:54:10.838Z",
    errorCode: "CHARGE.NOT_FOUND",
    feeValue: "0.025",
    fizenpayFeePerc: 0.5,
    id: "626b616223970700081a97041",
    netValue: "4.975",
    network: "binance-smart-chain-testnet",
    ownerId: "6268b18ca695650007097e70",
    payerAddress: "0xff93B45308FD417dF303D6515aB04D9e89a750Ca",
    paymentDate: "2022-04-29T03:54:10.838Z",
    status: "UNRESOLVED",
    tokenAddr: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
    tokenSymbol: "DAI",
    transactionHash: "0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    transactionUrl:
      "https://testnet.bscscan.com/tx/0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    updatedAt: "2022-04-29T03:54:10.838Z",
    remark:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Quas nemo, quibusdam quaerat ea totam doloremque quo praesentium labore molestiae eligendi quia magni, aut culpa deleniti adipisci aliquid! Repudiandae, at magnam!",
  },
  {
    amount: "5",
    blockHash: "0xd5a0ef6b90803adbcc09de5b71262d5bb67256572ab38d246ad5c08116c0e43f",
    blockNumber: 18858906,
    chargeCode: "UNLINKED_6",
    contracAddr: "0xE8BcC65c7a7931b61c8eE45af27b9C85083F35b9",
    createdAt: "2022-04-29T03:54:10.838Z",
    errorCode: "CHARGE.NOT_FOUND",
    feeValue: "0.025",
    fizenpayFeePerc: 0.5,
    id: "626b616223970700081a97042",
    netValue: "4.975",
    network: "binance-smart-chain-testnet",
    ownerId: "6268b18ca695650007097e70",
    payerAddress: "0xff93B45308FD417dF303D6515aB04D9e89a750Ca",
    paymentDate: "2022-04-29T03:54:10.838Z",
    status: "UNRESOLVED",
    tokenAddr: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
    tokenSymbol: "DAI",
    transactionHash: "0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    transactionUrl:
      "https://testnet.bscscan.com/tx/0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    updatedAt: "2022-04-29T03:54:10.838Z",
  },
  {
    amount: "5",
    blockHash: "0xd5a0ef6b90803adbcc09de5b71262d5bb67256572ab38d246ad5c08116c0e43f",
    blockNumber: 18858906,
    chargeCode: "UNLINKED_7",
    contracAddr: "0xE8BcC65c7a7931b61c8eE45af27b9C85083F35b9",
    createdAt: "2022-04-29T03:54:10.838Z",
    errorCode: "CHARGE.NOT_FOUND",
    feeValue: "0.025",
    fizenpayFeePerc: 0.5,
    id: "626b616223970700081a97043",
    netValue: "4.975",
    network: "binance-smart-chain-testnet",
    ownerId: "6268b18ca695650007097e70",
    payerAddress: "0xff93B45308FD417dF303D6515aB04D9e89a750Ca",
    paymentDate: "2022-04-29T03:54:10.838Z",
    status: "UNRESOLVED",
    tokenAddr: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
    tokenSymbol: "DAI",
    transactionHash: "0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    transactionUrl:
      "https://testnet.bscscan.com/tx/0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    updatedAt: "2022-04-29T03:54:10.838Z",
  },
  {
    amount: "5",
    blockHash: "0xd5a0ef6b90803adbcc09de5b71262d5bb67256572ab38d246ad5c08116c0e43f",
    blockNumber: 18858906,
    chargeCode: "UNLINKED_4",
    contracAddr: "0xE8BcC65c7a7931b61c8eE45af27b9C85083F35b9",
    createdAt: "2022-04-29T03:54:10.838Z",
    errorCode: "CHARGE.NOT_FOUND",
    feeValue: "0.025",
    fizenpayFeePerc: 0.5,
    id: "626b616223970700081a97044",
    netValue: "4.975",
    network: "binance-smart-chain-testnet",
    ownerId: "6268b18ca695650007097e70",
    payerAddress: "0xff93B45308FD417dF303D6515aB04D9e89a750Ca",
    paymentDate: "2022-04-29T03:54:10.838Z",
    resolved: {
      action: "FORWARDED_TO_MERCHANT",
      cryptoPrice: null,
      estimatedTransactionFeeByCrypto: "0",
      estimatedTransactionFeeByUSD: "0",
      resolvedAmount: "4.975",
      resolvedTransactionHash: null,
      resolvedTransactionUrl: null,
    },
    action: "FORWARDED_TO_MERCHANT",
    cryptoPrice: null,
    estimatedTransactionFeeByCrypto: "0",
    estimatedTransactionFeeByUSD: "0",
    resolvedAmount: "4.975",
    resolvedTransactionHash: null,
    resolvedTransactionUrl: null,
    status: "FORWARDED_TO_MERCHANT",
    tokenAddr: "0x460b248e24d2b14F59bf09a27fF73e4Bee7E140a",
    tokenSymbol: "DAI",
    transactionHash: "0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    transactionUrl:
      "https://testnet.bscscan.com/tx/0x3a34b3fde6a91c0e33e31c60df4f69471b4376f49463e8238fdd7f3ee5bfbd10",
    updatedAt: "2022-04-29T04:01:28.788Z",
  },
];

export const onGet = () => {
  axiosMockAdapterInstance.onGet("/unlinked-payments").reply(() => {
    return [200, getResponseData(data)];
  });
};
export const onPost = (id, values) => {
  axiosMockAdapterInstance.onPost(`/unlinked-payments/${id}/resolve`, values).reply(() => {
    return [200, getResponseData(data)];
  });
};
export const onUpdateNote = (id, values) => {
  axiosMockAdapterInstance.onPost(`/unlinked-payments/${id}/remark`, { values }).reply(() => {
    return [200, getResponseData(data)];
  });
};
